export default {
  title: {
    id: 'product_page_technical_specifications_title',
    defaultMessage: 'Under the hood',
  },
  button: {
    id: 'product_page_technical_specifications_button',
    defaultMessage: 'See all specifications',
  },
}
